/**
 * 页面编辑权限 page_key 常量（与后端 src/config/permissions.py 字面量严格一致）。
 *
 * 用户矩阵（page_key → 可编辑 user_id）**只在后端**，前端经
 * GET /api/v1/auth/permissions 读取当前用户的 editable_pages / is_admin，
 * 再由 AuthContext.canEdit(pageKey) 判定，避免双源漂移。
 */

export const PAGE_KEYS = {
  TENCENT_AD_NAME_TEMPLATE: "tencent:ad-name-template",
  TENCENT_REDLINE: "tencent:redline",
  TENCENT_STRATEGY: "tencent:strategy",
  /** 策略配置页「目标费率」卡片独立权限键（与整页开关 tencent:strategy 分离） */
  TENCENT_FEILV_TARGET: "tencent:feilv-target",
  /** T0广告看板「自定义账户集合」编辑权限键（用户组同腾讯红线/命名模板） */
  TENCENT_T0_DASHBOARD: "tencent:t0-dashboard",
  OCEAN_REDLINE: "ocean:redline",
  OCEAN_STRATEGY: "ocean:strategy",
  BAIDU_REDLINE: "baidu:redline",
  BAIDU_STRATEGY: "baidu:strategy",
  HUAWEI_AD_NAME_TEMPLATE: "huawei:ad-name-template",
  HUAWEI_REDLINE: "huawei:redline",
  HUAWEI_STRATEGY: "huawei:strategy",
  /** 华为商店策略配置页「目标费率与成本」卡片独立权限键（用户组同 huawei:strategy） */
  HUAWEI_FEILV_TARGET: "huawei:feilv-target",
  APPLE_AD_NAME_TEMPLATE: "apple:ad-name-template",
  /** Apple Ads 红线规则配置（投放时间 + 豁免关键词），用户组沿用华为红线配置 */
  APPLE_REDLINE: "apple:redline",
  /** Apple Ads 策略配置页「目标费率」卡片独立权限键（用户组同 apple:redline） */
  APPLE_FEILV_TARGET: "apple:feilv-target",
  /** Apple Ads 策略配置页「自定义策略配置」区块权限键（用户组同 apple:redline） */
  APPLE_WATCH_STRATEGY: "apple:watch-strategy",
  /** 华为商店策略配置页「自定义策略配置」区块权限键（用户组同 huawei:strategy） */
  HUAWEI_WATCH_STRATEGY: "huawei:watch-strategy",
} as const;

export type PageKey = (typeof PAGE_KEYS)[keyof typeof PAGE_KEYS];
